import { useEffect, useState } from 'react';
import { ContractCard } from '../../../components/ContractCard';
import { ContractDetailDialog } from '../../../components/ContractDetailDialog';
import { ArrowRight, FileText, Home, Sparkles } from 'lucide-react';
import { CallAPIGetPromise } from 'Common/commaon';
import { getDecodeId } from 'slices/userProfile/thunk';
import { toast } from 'sonner';
import { Toaster } from 'components/ui/sonner';
import './homeowner-dashboard.css';

export default function HomewownerContractStatus() {
  const [selectedContract, setSelectedContract] = useState<string | number | null>(null);
  const [signedContracts, setSignedContracts] = useState<any[]>([])
  const [totalContract, setTotalContracts] = useState<any[]>([])
  const [activeTab, setActiveTab] = useState<'pending' | 'signed' | 'total'>('pending');
  const [pendingontractsData,setPendingContractData]=useState<any[]>([])
  const [contractCount,setContractCount]=useState<any>("")
  const [refresh,setRefresh] =useState(false)
  const [loading, setLoading] = useState(true)
  const handleSign = (contractId: string) => {
    // setSignedContracts(prev => new Set([...prev, contractId]));
    setSelectedContract(null);
    toast.success("Contract Signed")
    setRefresh(r=>!r)
  };
  const getActiveContracts = () => {
    if (activeTab === 'pending') return pendingontractsData || [];
    if (activeTab === 'signed') return signedContracts || [];
    if (activeTab === 'total') return totalContract || [];
    return [];
  };
  

  useEffect(()=>{
    setLoading(true)
    CallAPIGetPromise(`/dashboard/get-homeownerContract-status/${getDecodeId()}`)
      .then((res:any)=>{
        if(res.data){
          const sortedContracts = [...(res.data.pendingContracts || [])].sort(
            (a: any, b: any) =>
              new Date(b.contractor_signed_on).getTime() -
              new Date(a.contractor_signed_on).getTime()
          );

          setPendingContractData(sortedContracts);
          setContractCount(res.data.counts)
          setSignedContracts(res.data.signedContracts || [])
          setTotalContracts(res.data.totalContracts || [])
        }
      })
      .catch(() => {
        setPendingContractData([])
        setSignedContracts([])
        setTotalContracts([])
      })
      .finally(() => setLoading(false))
  },[refresh])

  const activeContracts = getActiveContracts();
  const sectionTitle = activeTab === 'pending'
    ? 'Pending Signatures'
    : activeTab === 'signed'
      ? 'Signed Contracts'
      : 'All Contracts';

  return (
    <div className="w-100 homeowner-dashboard">
      <main>
        <section className="homeowner-dashboard__hero">
          <div className="homeowner-dashboard__hero-icon"><Home aria-hidden="true" /></div>
          <div className="homeowner-dashboard__hero-copy">
            <span><Sparkles size={14} /> HOMEOWNER OVERVIEW</span>
            <h1>Projects, people and property—at a glance</h1>
            <p>Review contract actions first, then explore professionals and properties selected for you.</p>
          </div>
          <div className="homeowner-dashboard__hero-links">
            <a href="/suggested-contractors">Find contractors <ArrowRight size={14} /></a>
            <a href="/recommended-properties">View properties <ArrowRight size={14} /></a>
          </div>
        </section>

        <div className="homeowner-dashboard__stats">
        <button
  type="button"
  className={`homeowner-stat-card homeowner-stat-card--pending${activeTab === 'pending' ? ' is-active' : ''}`}
  onClick={() => setActiveTab('pending')}
  aria-pressed={activeTab === 'pending'}
>
  <div className="homeowner-stat-card__label">
    <span><FileText aria-hidden="true" /></span>
    Pending signatures
  </div>
  <strong>{contractCount?.pending_sign_count || 0}</strong>
</button>

<button
  type="button"
  className={`homeowner-stat-card homeowner-stat-card--signed${activeTab === 'signed' ? ' is-active' : ''}`}
  onClick={() => setActiveTab('signed')}
  aria-pressed={activeTab === 'signed'}
>
  <div className="homeowner-stat-card__label">
    <span><FileText aria-hidden="true" /></span>
    Signed contracts
  </div>
  <strong>{contractCount?.signed_contract_count || 0}</strong>
</button>

<button
  type="button"
  className={`homeowner-stat-card homeowner-stat-card--total${activeTab === 'total' ? ' is-active' : ''}`}
  onClick={() => setActiveTab('total')}
  aria-pressed={activeTab === 'total'}
>
  <div className="homeowner-stat-card__label">
    <span><FileText aria-hidden="true" /></span>
    Total contracts
  </div>
  <strong>{contractCount?.total_contract_count || 0}</strong>
</button>

        </div>

        <section className="homeowner-dashboard__contracts">
          <header className="homeowner-dashboard__contracts-header">
            <div>
              <span>CONTRACT ACTIVITY</span>
              <h2>{sectionTitle}</h2>
              <p>{activeTab === 'pending' ? 'Items needing your attention appear first.' : 'Switch the summary cards above to change this view.'}</p>
            </div>
            <strong>{activeContracts.length}</strong>
          </header>

          <div className="homeowner-dashboard__contracts-viewport">
            {loading ? (
              <div className="homeowner-contract-empty"><span className="spinner-border spinner-border-sm" /><div><strong>Loading contracts…</strong><small>Your latest activity will appear here.</small></div></div>
            ) : activeContracts.length === 0 ? (
              <div className="homeowner-contract-empty">
                <FileText aria-hidden="true" />
                <div><strong>No contracts here</strong><small>{activeTab === 'pending' ? "You're all caught up — nothing pending!" : activeTab === 'signed' ? "No signed contracts found." : "No contracts found."}</small></div>
              </div>
            ) : (
              <div className="homeowner-contract-list">
                {activeContracts.map((contract: any) => (
                  <ContractCard
                    key={contract.contract_project_id}
                    contract={contract}
                    type={activeTab}
                    onViewDetails={() => setSelectedContract(contract.contract_project_id)}
                  />
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      {/* Contract Detail Dialog */}
      {selectedContract && (
        <ContractDetailDialog
          contractID={selectedContract}
          onClose={() => setSelectedContract(null)}
          onSign={handleSign}
        />
      )}
      <Toaster position={'top-right'} />
    </div>
  );
}
